
import { CardContent } from "@/components/ui/card";
import ChatPreviewItem from "./ChatPreviewItem";
import { ChatPreview } from "./types";

type ChatPreviewListProps = {
  chats: ChatPreview[];
  selectedChatId?: string;
  onSelectChat: (chatId: string) => void;
  searchQuery: string;
};

const ChatPreviewList = ({ 
  chats, 
  selectedChatId, 
  onSelectChat,
  searchQuery 
}: ChatPreviewListProps) => {
  const filteredChats = chats.filter(chat => 
    chat.user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    chat.lastMessage.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <CardContent className="h-full overflow-y-auto pt-2">
      <div className="space-y-1">
        {filteredChats.length === 0 ? (
          <p className="text-center text-muted-foreground py-4">
            {searchQuery ? "No conversations match your search" : "No conversations yet"}
          </p>
        ) : (
          filteredChats.map((chat) => (
            <ChatPreviewItem
              key={chat.id}
              chat={chat}
              selected={selectedChatId === chat.id}
              onSelect={() => onSelectChat(chat.id)}
            />
          ))
        )}
      </div>
    </CardContent>
  );
};

export default ChatPreviewList;
